import type { LayerKey } from '@festina-life/api'
import type { Optional } from '@festina-life/core'
import type { SearchResult } from '@festina-life/ui/search'

import type { ConfigurationItem } from '../../types/common'

export type ConfigurationSearchItem = {
  id: string
  operationType: Exclude<
    ConfigurationItem,
    'annulOperation' | 'parameterValueAmendOperation' | 'parameterValue'
  >
  type: Optional<string>
  layer: LayerKey
  block: string
  packageName: Optional<string>
  isDraft: boolean
}
export type ConfigurationItemSearchMatch = {
  isExpression: boolean
  match: string
  propertyPath?: string
}

export type ConfigurationItemSearchResult = SearchResult<
  ConfigurationSearchItem,
  ConfigurationItemSearchMatch,
  SearchCategoryKey
>

export type ConfigurationItemSearchFunctions = {
  name: (query: string) => Promise<ConfigurationItemSearchResult[]>
  className: (query: string) => Promise<ConfigurationItemSearchResult[]>
  properties: (query: string) => Promise<ConfigurationItemSearchResult[]>
  fplus: (query: string) => Promise<ConfigurationItemSearchResult[]>
  all: (query: string) => Promise<ConfigurationItemSearchResult[]>
}

export const SearchCategories = {
  itemId: 'itemId',
  class: 'class',
  properties: 'properties',
  fplus: 'fplus',
  all: 'all',
} as const

export type SearchCategoryKey = keyof typeof SearchCategories
